import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Slide from '@ifeng/ui_pc_slides';
import styles from './index.css';
import { handleSlideData } from '../../../../../utils/handleSlideData';
import { rel } from '../../../../../utils/rel';
import { formatImage } from '@ifeng/public_method';

const CustomSlide = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
            title: PropTypes.string,
            mode: PropTypes.string,
        };

        constructor(props) {
            super(props);

            const { mode, content } = props;

            this.state = {
                sliderData: mode === 'mix' ? handleSlideData(content) : content,
            };
        }

        mixSliderTmpl = eachFrame => {
            return (
                <div className={styles.bottomnews_main}>
                    <div className={styles.bottomnews_main_bimg}>
                        <a href={eachFrame[0].url} target="_blank" rel={rel}>
                            <img src={formatImage(eachFrame[0].thumbnail, 598, 372)} alt={eachFrame[0].title} />
                        </a>
                        <h2>
                            <a href={eachFrame[0].url} target="_blank" rel={rel}>
                                {eachFrame[0].title}
                            </a>
                        </h2>
                    </div>
                    <div className={styles.bottomnews_main_r}>
                        <div className={styles.bottomnews_main_simgs}>
                            <div className={styles.bottomnews_main_simg_02}>
                                <a href={eachFrame[1].url} target="_blank" rel={rel}>
                                    <img src={formatImage(eachFrame[1].thumbnail, 398, 185)} alt={eachFrame[1].title} />
                                </a>
                                <h2>
                                    <a href={eachFrame[1].url} target="_blank" rel={rel}>
                                        {eachFrame[1].title}
                                    </a>
                                </h2>
                            </div>
                            <div className={styles.bottomnews_main_simg}>
                                <a href={eachFrame[2].url} target="_blank" rel={rel}>
                                    <img src={formatImage(eachFrame[2].thumbnail, 198, 185)} alt={eachFrame[2].title} />
                                </a>
                                <h2>
                                    <a href={eachFrame[2].url} target="_blank" rel={rel}>
                                        {eachFrame[2].title}
                                    </a>
                                </h2>
                            </div>
                            <div className={styles.bottomnews_main_simg}>
                                <a href={eachFrame[3].url} target="_blank" rel={rel}>
                                    <img src={formatImage(eachFrame[3].thumbnail, 198, 185)} alt={eachFrame[3].title} />
                                </a>
                                <h2>
                                    <a href={eachFrame[3].url} target="_blank" rel={rel}>
                                        {eachFrame[3].title}
                                    </a>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        pureSliderTmpl = item => {
            return (
                <div className={styles.pureSlide}>
                    <a href={item.url} target="_blank" rel={rel}>
                        <img src={item.thumbnail} />
                    </a>
                    <p>
                        <a href={item.url} target="_blank" rel={rel}>
                            <img src="//p0.ifengimg.com/fe/sports_index_new/images/bg_v_1406f026.png" />
                            {item.title}
                        </a>
                    </p>
                </div>
            );
        };

        render() {
            const { title, mode } = this.props;

            const { sliderData } = this.state;

            const slideConfig = {
                sliderTmpl: mode === 'mix' ? this.mixSliderTmpl : this.pureSliderTmpl,
                autoplay: mode === 'mix',
                dots: false,
                arrows: true,
                unitSize: mode === 'mix' ? 1000 : 255,
                extension: mode === 'mix' ? 2 : 4,
            };

            return (
                <div className={styles.gq_pic}>
                    <div className={styles.col_title}>{title}</div>
                    <div className={mode === 'mix' ? styles.mixBanner : styles.pureBanner}>
                        <Slide content={sliderData} config={slideConfig} />
                    </div>
                </div>
            );
        }
    },
);

export { CustomSlide };
export default CustomSlide;
